<template>
  <div class="back">
    <button @click="$emit('clickedButton')" class="back-button">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 5.16" class="back-arrow">
        <g class="arrow">
          <path class="cls-1" d="M35.5,5.16H.5A.5.5,0,0,1,0,4.85.49.49,0,0,1,.15,4.3L4.3.15A.5.5,0,0,1,5,.15a.48.48,0,0,1,0,.7L1.71,4.16H35.5a.5.5,0,0,1,.5.5A.5.5,0,0,1,35.5,5.16Z"/>
        </g>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.05 9.98" class="back-text">
        <g class="text cls-2">
          <path class="cls-1" d="M.11,3.79c0-.61,0-1.22,0-1.82S0,.78,0,.18L.74.23c.25,0,.5,0,.74,0s.49,0,.75,0A6.23,6.23,0,0,1,3,.18,6.72,6.72,0,0,1,4.1.27,2.68,2.68,0,0,1,5,.6a1.66,1.66,0,0,1,.64.62,1.85,1.85,0,0,1,.24,1,2,2,0,0,1-.65,1.62,3.72,3.72,0,0,1-1.7.83v0a3.37,3.37,0,0,1,2,.6A2.05,2.05,0,0,1,6.26,7a2.52,2.52,0,0,1-.32,1.31,2.69,2.69,0,0,1-.84.87A3.79,3.79,0,0,1,4,9.67a5.87,5.87,0,0,1-1.24.13H2l-.68,0H.68c-.23,0-.46,0-.68,0C0,9.2.05,8.61.08,8s0-1.2,0-1.82ZM2,4.48a4.57,4.57,0,0,0,1-.1,2.41,2.41,0,0,0,.86-.33,1.87,1.87,0,0,0,.61-.61,1.92,1.92,0,0,0,.23-1,1.73,1.73,0,0,0-.21-.91A1.49,1.49,0,0,0,4,1,2.19,2.19,0,0,0,3.22.76,5.52,5.52,0,0,0,2.41.7l-.62,0L1.34.77c0,.45,0,.89-.05,1.33s0,.88,0,1.33V4.48ZM1.26,6.43q0,.71,0,1.41c0,.47,0,.94.05,1.41L2,9.3c.25,0,.49,0,.75,0a2.55,2.55,0,0,0,.86-.15,2.08,2.08,0,0,0,.72-.45A2.32,2.32,0,0,0,4.79,8,2.59,2.59,0,0,0,5,7a1.9,1.9,0,0,0-.22-1,1.52,1.52,0,0,0-.62-.61,3.16,3.16,0,0,0-1-.3A9.7,9.7,0,0,0,1.89,5H1.26Z"/>
          <path class="cls-1" d="M20.08,9.8l-.37,0H19l-.37,0c-.06-.21-.15-.47-.26-.78L18,8.07l-.42-1c-.14-.34-.27-.66-.39-1l-.91,0H14.46l-.85,0c-.3.73-.57,1.42-.81,2.08s-.43,1.2-.55,1.63a4.52,4.52,0,0,0-1,0c.76-1.63,1.5-3.26,2.22-4.87S14.87,1.67,15.6,0h.26c.23.54.47,1.13.73,1.76l.8,1.91.81,1.92L19,7.36l.65,1.46A10.5,10.5,0,0,0,20.08,9.8ZM13.87,5.45h2.3l.78,0L15.4,1.89Z"/>
          <path class="cls-1" d="M32.3,9.47a3.71,3.71,0,0,1-.65.24c-.26.07-.55.13-.86.19a6.43,6.43,0,0,1-1,.08,6.33,6.33,0,0,1-2-.31,4.26,4.26,0,0,1-1.62-1,4.49,4.49,0,0,1-1.06-1.58A5.42,5.42,0,0,1,24.68,5a5.45,5.45,0,0,1,.39-2.12,4.34,4.34,0,0,1,1.07-1.57,4.68,4.68,0,0,1,1.66-1A6.34,6.34,0,0,1,29.93,0a6.83,6.83,0,0,1,1.69.19A8.88,8.88,0,0,1,33,.64a1.89,1.89,0,0,0-.18.54c0,.22-.09.41-.11.56l-.09,0a2.86,2.86,0,0,0-.39-.37A4.05,4.05,0,0,0,31.61,1a3.69,3.69,0,0,0-.75-.33,3,3,0,0,0-.93-.13A4.47,4.47,0,0,0,28.4.78a3.41,3.41,0,0,0-1.23.82A3.79,3.79,0,0,0,26.35,3a6.08,6.08,0,0,0-.3,2,6,6,0,0,0,.3,2,3.71,3.71,0,0,0,.82,1.4,3.28,3.28,0,0,0,1.23.82,4.24,4.24,0,0,0,1.53.27,3.37,3.37,0,0,0,.93-.13,4.32,4.32,0,0,0,.79-.3,4.91,4.91,0,0,0,.64-.38,6,6,0,0,0,.48-.36l.06.06-.13.83A1.79,1.79,0,0,1,32.3,9.47Z"/>
          <path class="cls-1" d="M38.89,9.8c0-.58.06-1.17.08-1.76s0-1.21,0-1.82V3.81c0-.62,0-1.22,0-1.81s0-1.2-.08-1.82l.35.05a1.94,1.94,0,0,0,.34,0,1.83,1.83,0,0,0,.33,0l.35-.05c0,.62,0,1.22-.07,1.82s0,1.19,0,1.81v.77c0,.07,0,.11.09.11a.4.4,0,0,0,.19-.13c.33-.28.67-.59,1-.95s.72-.72,1.09-1.1l1.07-1.17,1-1.16.29.05a1.32,1.32,0,0,0,.28,0,2,2,0,0,0,.34,0l.33-.05c-.32.28-.69.61-1.1,1S44,2,43.55,2.35s-.81.8-1.19,1.19-.7.72-1,1c.76.85,1.52,1.72,2.29,2.6s1.55,1.76,2.35,2.65a3,3,0,0,0-.42,0h-.81l-.38,0c-.34-.38-.71-.82-1.12-1.32L42.13,7.05c-.38-.46-.73-.88-1.05-1.25s-.54-.62-.69-.77-.13-.12-.17-.12-.07,0-.07.09V6.22c0,.61,0,1.22,0,1.82s.05,1.18.07,1.76c-.21,0-.44,0-.68,0S39.11,9.78,38.89,9.8Z"/>
        </g>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ButtonBack',
}
</script>

<style lang="scss" scoped>
.back {
  padding: 0 0 29/375 * 100% 20/375 * 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  @include media() {
    padding: 0 0 40px 40px;
  }
  &-button {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
  }
  &-arrow {
    width: 24/375 * 100vw;
    fill: #333;
    @include media() {
      width: 36px;
      transition: .45s ease;
      .back-button:hover & {
        fill: #DF0068;
      }
    }
  }
  &-text {
    width: 34/375 * 100vw;
    margin-left: 10/375 * 100vw;
    isolation:isolate;
    fill: #333;
    @include media() {
      width: 47px;
      margin-left: 15px;
      transition: .45s ease;
      .back-button:hover & {
        fill: #DF0068;
      }
    }
  }
}
</style>
